import { ToastService } from 'src/app/main/bootstrap/toast/ToastService';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Privileges use for accessing each task
const DATA_UTILITY: String = 'CAC_CRP_DATA_UTILITY'
const SUPERVISOR: String = 'CAC_CRP_DATA_ENTRY_POST_SUPERVISOR'
const EDIT_ENTITY: String = 'CAC_CRP_PRE_DATA_ENTRY_EDIT_ENTITY'
const SEARCH: String = 'CAC_CRP_POST_DATA_ENTRY_SEARCH'
const PRE_DATA_ENTRY: String = 'CAC_CRP_PRE_DATA_ENTRY'
const POST_DATA_ENTRY: String = 'CAC_CRP_POST_DATA_ENTRY'

//Main Role use to Login
const DATA_ENTRY: String = 'CAC_CRP_POST_DATA_ENTRY_OFFICER'
const CAC_CRP_ESCALATION_OFFICER_2: String = 'CAC_CRP_ESCALATION_OFFICER_2'
const CAC_CRP_ESCALATION_OFFICER_1: String = 'CAC_CRP_ESCALATION_OFFICER_1'
const CAC_CRP_DATA_ENTRY_RG: String = 'CAC_CRP_DATA_ENTRY_RG'
const CAC_CRP_DATA_ENTRY_OFFICER: String = 'CAC_CRP_DATA_ENTRY_OFFICER'
const CAC_CRP_ACCREDITED_AGENT: String = 'CAC_CRP_ACCREDITED_AGENT'
const CAC_CRP_COMPANY_DELETE: String = 'CAC_CRP_COMPANY_DELETE'


// CAC_CRP_PRE_DATA_ENTRY
// CAC_CRP_ESCALATION_OFFICER_2
// CAC_CRP_ESCALATION_OFFICER_1
// CAC_CRP_DATA_ENTRY_RG
// CAC_CRP_DATA_ENTRY_OFFICER
// CAC_CRP_POST_DATA_ENTRY
// CAC_CRP_POST_DATA_ENTRY_SEARCH
// CAC_CRP_PRE_DATA_ENTRY_EDIT_ENTITY
// CAC_CRP_DATA_ENTRY_POST_SUPERVISOR



@Injectable({
  providedIn: 'root'
})
export class RolePrivilegeManagerService {
  role: any[] = [];

  constructor(private route: Router, private toastr: ToastService) {
    this.role = JSON.parse(sessionStorage.getItem('PortalUserRole'))
    if (this.role == null) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }

  dataEntryOfficer() {
    return !!this.role?.includes(CAC_CRP_DATA_ENTRY_OFFICER);
  }

  notDataEntryOfficer() {
    if (this.role?.includes(CAC_CRP_ESCALATION_OFFICER_1) ||
      this.role?.includes(CAC_CRP_ESCALATION_OFFICER_2) ||
      this.role?.includes(CAC_CRP_DATA_ENTRY_RG)) {
      return true;
    }
    return false;

  }

  accreditedAgent(): boolean {
    return this.role?.includes(CAC_CRP_ACCREDITED_AGENT)

  }
  deleteCompany(): boolean {
    return this.role?.includes(CAC_CRP_COMPANY_DELETE)
  }

  utility(): boolean {
    return this.role?.includes(DATA_UTILITY)
  }

  supervisor(): boolean {
    return this.role?.includes(SUPERVISOR)
  }
  search(): boolean {
    return (this.role?.includes(SEARCH));
  }

  editEntity(): boolean {
    return !!this.role?.includes(EDIT_ENTITY);
  }

  preDataEntry() {
    // return true
    if (this.role?.includes(PRE_DATA_ENTRY)) {
      return true
    }
    return false;
  }
  postDataEntry() {
    // return true
    if (this.role?.includes(POST_DATA_ENTRY)) {
      return true
    }
    return false;
  }

// form
  activeSupervisor(form: FormGroup[]) {
    let active = Boolean(sessionStorage.getItem('activeSupervior'))
    if (active) {
      form.forEach(r => {
        r.disable()
      })
      // form.disable()
      return active;
    }
    return false;
  }

  activeSupervisorCompany() {
    let active = Boolean(sessionStorage.getItem('activeSupervior'))
    return active;
  }


}
